var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0801 1.94445C15.45 1.57432 16.0499 1.57407 16.4202 1.94389L18.0554 3.57718C18.4258 3.94716 18.426 4.54737 18.056 4.91766L10.3368 12.6408C10.2048 12.7729 10.0367 12.863 9.85365 12.8999L6.40543 13.5947L7.10148 10.1506C7.1384 9.96795 7.22835 9.80022 7.3601 9.6684L15.0801 1.94445Z",
    fill: "#00FF38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24868 3.16976H4.50993C2.93965 3.16976 1.66669 4.44269 1.66669 6.01292V15.4902C1.66669 17.0604 2.93965 18.3334 4.50993 18.3334H13.9874C15.5577 18.3334 16.8307 17.0604 16.8307 15.4902L16.8307 10.7516M6.40543 13.5947L9.85365 12.8999C10.0367 12.863 10.2048 12.7729 10.3368 12.6408L18.056 4.91766C18.426 4.54737 18.4258 3.94716 18.0554 3.57718L16.4202 1.94389C16.0499 1.57407 15.45 1.57432 15.0801 1.94445L7.3601 9.6684C7.22835 9.80022 7.1384 9.96795 7.10148 10.1506L6.40543 13.5947Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.7c8b0689aaed4a454b456fff0fe0e03a.svg";
export { ForwardRef as ReactComponent };